import React from 'react'
import PageTitle from '../../components/PageTitle'
import ServicesMainSection from './components/ServicesMainSection'
import useServiceTemplate from '../../hooks/templates/useServiceTemplate'

const Services = () => {
  useServiceTemplate();
  return (
    <>
     <PageTitle title="Services" />
     <ServicesMainSection />
    </>
  )
}

export default Services